module.exports = __webpack_public_path__ + "img/cat-hand-book.82614f01.png";